<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Committee</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-select v-model="addData.position" :items="rolesList" :item-text="'name'" :item-value="'id'"
              label="Committee position" dense outlined></v-select>
          </v-col>
          <v-col cols="5" md="5" sm="12">
            <AutocompleteSearch @changeData="addData.member = $event" :storeLink="'member/getServiceProjectMembers'"
              :setectVale="addData.member" :itemText="'name'" :id="uuid" />
          </v-col>
          <v-col cols="1" md="1" sm="12">
            <v-btn large color="green" depressed :disabled="loading || !addData.member || !addData.position" block
              @click="add()">Add</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <CommitteMembersList :members="members" @deleteMember="deleteMember($event)"></CommitteMembersList>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="previous()">Previous</v-btn>
          </v-col>
          <v-col cols="12" md="6" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading || members.length === 0" block
              @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import CommitteMembersList from "../create/child/CommitteMembersList";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, Snackbars, CommitteMembersList, AutocompleteSearch },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    addData: {
      position: null,
      member: null
    },
    type: localStorage.getItem("service_project_type") || null,
    members: [],
    rolesList: [
      {
        id: "Project Chairman",
        name: "Project Chairman",
      },
      {
        id: "Project co-chairman",
        name: "Project co-chairman",
      },
      {
        id: "Committee Member",
        name: "Committee Member",
      },
    ],
  }),

  mounted() {
    this.getCommitteeMemberList();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 3, uuid: this.uuid } })
    },
    previous() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 1, uuid: this.uuid } })
    },

    add() {
      if (this.uuid !== null) {
        this.addData.project_id = this.uuid;
        ProjectService.createCommitteeMembers(this.addData)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.getCommitteeMemberList();
              this.reset();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    getCommitteeMemberList() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getCommitteeMemberList(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.members = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.members = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    deleteMember(uuid) {
      if (uuid !== null) {
        ProjectService.deleteProjectCommittee(uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.status_code === 200) {
              this.getCommitteeMemberList();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.addData.position = null;
      this.addData.member = null;
    },
  },
};
</script>
